module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "ote_white_with_black_background.721227d1.svg";